import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { RoutingConstants } from "../../constants/routingConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { DataCdtService } from "../data-cdt.service";
import { CommonService } from "src/app/core/services/common.service";

@Component({
  selector: "app-create-edit-data-cdt",
  templateUrl: "./create-edit-data-cdt.component.html",
  styleUrls: ["./create-edit-data-cdt.component.scss"],
})
export class CreateEditDataCdtComponent implements OnInit {
  public routing = RoutingConstants.dataCDTRouting;
  dataCDT;
  operation: string;

  sectionHidden = {
    datosCabecera: false,
    datosCarroceria: false,
    direccionSuspensionFrenos: false,
    ejesYruedas: false,
    emisisionesCo2Consumo: false,
    emisionesEscape: false,
    datosGenerales: false,
    masas: false,
    motorGeneral: false,
    motorNivelSonido: false,
    transmision: false,
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastrAlertService: ToastrAlertService,
    private dataCdtService: DataCdtService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.initFormGroup();
    this.operation = this.activatedRoute.data["_value"]["operation"];
    if (
      this.operation === "edicion" &&
      this.activatedRoute.snapshot.params.id
    ) {
      this.getDataCdt();
    }
  }

  getDataCdt() {
    let id = this.activatedRoute.snapshot.params.id;
    this.dataCdtService.getOne(id).subscribe(
      (data) => {
        this.setValues(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  onUpdate() {
    this.dataCdtService.updateOne(this.dataCDT.value).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(
          data["mensaje"],
          this.routing.list
        );
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  onCreate() {
    this.dataCdtService.createOne(this.dataCDT.value).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(
          data["mensaje"],
          this.routing.list
        );
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.dataCDT.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      if (this.operation === "edicion") {
        this.onUpdate();
      } else if (this.operation === "creacion") {
        this.onCreate();
      }
    }
  }

  goList() {
    this.router.navigate([this.routing.list]);
  }

  setValues(data) {
    this.dataCDT.patchValue({
      capacidadDeposito: data.capacidadDeposito,
      daAhorroCo2Diesel: data.daAhorroCo2Diesel,
      daAhorroCo2Gas: data.daAhorroCo2Gas,
      daAhorroCo2Otros: data.daAhorroCo2Otros,
      daAlimCombustible: data.daAlimCombustible,
      daAlturaMax: data.daAlturaMax,
      daAlturaMin: data.daAlturaMin,
      daAnchoMaxCarr: data.daAnchoMaxCarr,
      daAnchuraMax: data.daAnchuraMax,
      daAnchuraMin: data.daAnchuraMin,
      daAsistencia: data.daAsistencia,
      daAutonomiaElectrica: data.daAutonomiaElectrica,
      daBarraSuspDelante: data.daBarraSuspDelante,
      daBarraSuspTrasera: data.daBarraSuspTrasera,
      daCajaCambios: data.daCajaCambios,
      daCargaPtoEnganCent: data.daCargaPtoEnganCent,
      daCategoria: data.daCategoria,
      daCilindrada: data.daCilindrada,
      daClasificVehiculo: data.daClasificVehiculo,
      daCodigocdt: data.daCodigocdt,
      daCodigoMotor: data.daCodigoMotor,
      daCombustible: data.daCombustible,
      daConsumoCombi: data.daConsumoCombi,
      daConsumoElectrico: data.daConsumoElectrico,
      daConsumoExtraurb: data.daConsumoExtraurb,
      daConsumoNumDirBase: data.daConsumoNumDirBase,
      daConsumoUltVersDir: data.daConsumoUltVersDir,
      daConsumoUrbano: data.daConsumoUrbano,
      daContrasenaGnc: data.daContrasenaGnc,
      daContrasenya: data.daContrasenya,
      daDenominacion: data.daDenominacion,
      daDirFabBase: data.daDirFabBase,
      daDirFabUtl: data.daDirFabUtl,
      daDireccion: data.daDireccion,
      daDispPuertas: data.daDispPuertas,
      daDisposicionCilindros: data.daDisposicionCilindros,
      daDispositivoFrenado: data.daDispositivoFrenado,
      daDispositivosAlumbrado: data.daDispositivosAlumbrado,
      daDistanciaEjes: data.daDistanciaEjes,
      daDistanciaEjes23: data.daDistanciaEjes23,
      daDistanciaEjes5Ult: data.daDistanciaEjes5Ult,
      daEjes: data.daEjes,
      daEjesMotores: data.daEjesMotores,
      daEmiEscapeEnsayo1: data.daEmiEscapeEnsayo1,
      daEmiEscapeEnsayo2: data.daEmiEscapeEnsayo2,
      daEmiEscapeFaseAplic: data.daEmiEscapeFaseAplic,
      daEmiEscapeNumDirBase: data.daEmiEscapeNumDirBase,
      daEmiEscapeUltVersDir: data.daEmiEscapeUltVersDir,
      daEmisionCo2: data.daEmisionCo2,
      daEmisionesExtraurb: data.daEmisionesExtraurb,
      daEmisionesUrbanas: data.daEmisionesUrbanas,
      daEmplazAsientos: data.daEmplazAsientos,
      daEscapeEnsayo1Co: data.daEscapeEnsayo1Co,
      daEscapeEnsayo1Hc: data.daEscapeEnsayo1Hc,
      daEscapeEnsayo1Hcnox: data.daEscapeEnsayo1Hcnox,
      daEscapeEnsayo1Humo: data.daEscapeEnsayo1Humo,
      daEscapeEnsayo1Nox: data.daEscapeEnsayo1Nox,
      daEscapeEnsayo1Partic: data.daEscapeEnsayo1Partic,
      daEscapeEnsayo2Co: data.daEscapeEnsayo2Co,
      daEscapeEnsayo2Hc: data.daEscapeEnsayo2Hc,
      daEscapeEnsayo2Hcnox: data.daEscapeEnsayo2Hcnox,
      daEscapeEnsayo2Humo: data.daEscapeEnsayo2Humo,
      daEscapeEnsayo2Nox: data.daEscapeEnsayo2Nox,
      daEscapeEnsayo2Partic: data.daEscapeEnsayo2Partic,
      daExtension: data.daExtension,
      daFabMarcaMotor: data.daFabMarcaMotor,
      daFechaHomologacion: data.daFechaHomologacion,
      daHumos: data.daHumos,
      daId: data.daId,
      daIndEcoinnovacion: data.daIndEcoinnovacion,
      daInyeccDirecta: data.daInyeccDirecta,
      daLlantasAnterior: data.daLlantasAnterior,
      daLlantasPosterior: data.daLlantasPosterior,
      daLongitudMax: data.daLongitudMax,
      daLongitudMaximaAdmMax: data.daLongitudMaximaAdmMax,
      daLongitudMaximaAdmMin: data.daLongitudMaximaAdmMin,
      daLongitudMin: data.daLongitudMin,
      daMarca: data.daMarca,
      daMarcaHomolCeDispEng: data.daMarcaHomolCeDispEng,
      daMarcaHomolDispEng: data.daMarcaHomolDispEng,
      daMasaMinimaAdmisibleMax: data.daMasaMinimaAdmisibleMax,
      daMasaMinimaAdmisibleMin: data.daMasaMinimaAdmisibleMin,
      daMma1Max: data.daMma1Max,
      daMma1Min: data.daMma1Min,
      daMma2Max: data.daMma2Max,
      daMma2Min: data.daMma2Min,
      daMmaMax: data.daMmaMax,
      daMmaMin: data.daMmaMin,
      daMmacMax: data.daMmacMax,
      daMmacMin: data.daMmacMin,
      daMmatMax: data.daMmatMax,
      daMmatMin: data.daMmatMin,
      daMmrBarraTraccion: data.daMmrBarraTraccion,
      daMmrConFrenos: data.daMmrConFrenos,
      daMmrSemiremolque: data.daMmrSemiremolque,
      daMmrSinFrenos: data.daMmrSinFrenos,
      daMmta1Max: data.daMmta1Max,
      daMmta1Min: data.daMmta1Min,
      daMmta2Max: data.daMmta2Max,
      daMmta2Min: data.daMmta2Min,
      daMmtaConjunto: data.daMmtaConjunto,
      daMmtcMax: data.daMmtcMax,
      daMmtcMin: data.daMmtcMin,
      daMomMax: data.daMomMax,
      daMomMin: data.daMomMin,
      daAutoridadGnc: data.daAutoridadGnc,
      daNeumaticosAnterior: data.daNeumaticosAnterior,
      daNeumaticosPosterior: data.daNeumaticosPosterior,
      daNivelEmisiones: data.daNivelEmisiones,
      daNivelRuidoParadoU1: data.daNivelRuidoParadoU1,
      daNivelRuidoParadoU2: data.daNivelRuidoParadoU2,
      daNomFabBase: data.daNomFabBase,
      daNomFabUlt: data.daNomFabUlt,
      daNumAsientosSinConduc: data.daNumAsientosSinConduc,
      daNumDepositos: data.daNumDepositos,
      daNumeroCilindros: data.daNumeroCilindros,
      daNumeroPlazasAsiento: data.daNumeroPlazasAsiento,
      daNumPuertas: data.daNumPuertas,
      daObsCoc: data.daObsCoc,
      daObsFamilia: data.daObsFamilia,
      daObsOpcHomol: data.daObsOpcHomol,
      daParteFijaVin: data.daParteFijaVin,
      daPotNominalKw: data.daPotNominalKw,
      daPotencia: data.daPotencia,
      daPrincipioMotor: data.daPrincipioMotor,
      daProcedencia: data.daProcedencia,
      daRegimenGiroPotMax: data.daRegimenGiroPotMax,
      daRpmCorte: data.daRpmCorte,
      daRuedas: data.daRuedas,
      daRuedasGemelas: data.daRuedasGemelas,
      daTcambio: data.daTcambio,
      daTcarroceria: data.daTcarroceria,
      daTcarroceriaDesc: data.daTcarroceriaDesc,
      daTextoEcoinn: data.daTextoEcoinn,
      daTipo: data.daTipo,
      daTipoCaja: data.daTipoCaja,
      daTipoEmbrague: data.daTipoEmbrague,
      daTipoVehiElec: data.daTipoVehiElec,
      daTraccion: data.daTraccion,
      daVariante: data.daVariante,
      daVelocidadMaxima: data.daVelocidadMaxima,
      daVersion: data.daVersion,
      daViaEjeAnteriorMax: data.daViaEjeAnteriorMax,
      daViaEjeAnteriorMin: data.daViaEjeAnteriorMin,
      daViaEjePosteriorMax: data.daViaEjePosteriorMax,
      daViaEjePosteriorMin: data.daViaEjePosteriorMin,
      daVoladMaxPostCarr: data.daVoladMaxPostCarr,
      daVoladizoTraseroMax: data.daVoladizoTraseroMax,
      daVoladizoTraseroMin: data.daVoladizoTraseroMin,
      daVolumenBodega: data.daVolumenBodega,
      daTmotor: data.daTmotor,
      dapotenciaNominal: data.dapotenciaNominal,
      daDirFabUlt: data.daDirFabUlt,
      daCapacidadDeposito: data.daCapacidadDeposito,
      daMmtaMin: data.daMmtaMin,
      daMmtaMax: data.daMmtaMax,
    });
  }

  initFormGroup() {
    this.dataCDT = new FormGroup({
      daAhorroCo2Diesel: new FormControl("", Validators.maxLength(5)),
      daAhorroCo2Gas: new FormControl("", Validators.maxLength(5)),
      daAhorroCo2Otros: new FormControl("", Validators.maxLength(5)),
      daAlimCombustible: new FormControl("", Validators.maxLength(4)),
      daAlturaMax: new FormControl(""), ///number
      daAlturaMin: new FormControl(""), //number
      daAnchoMaxCarr: new FormControl("", Validators.maxLength(11)),
      daAnchuraMax: new FormControl(""), //number
      daAnchuraMin: new FormControl(""), //number
      daAsistencia: new FormControl("", Validators.maxLength(50)),
      daAutonomiaElectrica: new FormControl("", Validators.maxLength(6)),
      daBarraSuspDelante: new FormControl("", Validators.maxLength(3)),
      daBarraSuspTrasera: new FormControl("", Validators.maxLength(3)),
      daCajaCambios: new FormControl("", Validators.maxLength(16)),
      daCapacidadDeposito: new FormControl(""), //number
      daCargaPtoEnganCent: new FormControl("", Validators.maxLength(11)),
      daCategoria: new FormControl("", Validators.maxLength(10)),
      daCilindrada: new FormControl(""), //number
      daClasificVehiculo: new FormControl("", Validators.maxLength(10)),
      daCodigoMotor: new FormControl("", Validators.maxLength(20)),
      daCodigocdt: new FormControl("", Validators.maxLength(60)),
      daCombustible: new FormControl("", Validators.maxLength(30)),
      daConsumoCombi: new FormControl(""), //number
      daConsumoElectrico: new FormControl("", Validators.maxLength(6)),
      daConsumoExtraurb: new FormControl(""), //number
      daConsumoNumDirBase: new FormControl("", Validators.maxLength(20)),
      daConsumoUltVersDir: new FormControl("", Validators.maxLength(20)),
      daConsumoUrbano: new FormControl(""), //number
      daContrasenaGnc: new FormControl("", Validators.maxLength(20)),
      daContrasenya: new FormControl("", Validators.maxLength(25)),
      daDenominacion: new FormControl("", Validators.maxLength(65)),
      daDirFabBase: new FormControl("", Validators.maxLength(100)),
      daDirFabUlt: new FormControl("", Validators.maxLength(100)),
      daDireccion: new FormControl("", Validators.maxLength(50)),
      daDispPuertas: new FormControl("", Validators.maxLength(50)),
      daDisposicionCilindros: new FormControl("", Validators.maxLength(15)),
      daDispositivoFrenado: new FormControl("", Validators.maxLength(250)),
      daDispositivosAlumbrado: new FormControl("", Validators.maxLength(3)),
      daDistanciaEjes: new FormControl(""), //number
      daDistanciaEjes23: new FormControl(""), ///number
      daDistanciaEjes5Ult: new FormControl(""), //number
      daEjes: new FormControl(""), //number
      daEjesMotores: new FormControl("", Validators.maxLength(30)),
      daEmiEscapeEnsayo1: new FormControl("", Validators.maxLength(50)),
      daEmiEscapeEnsayo2: new FormControl("", Validators.maxLength(50)),
      daEmiEscapeFaseAplic: new FormControl("", Validators.maxLength(2)),
      daEmiEscapeNumDirBase: new FormControl("", Validators.maxLength(15)),
      daEmiEscapeUltVersDir: new FormControl("", Validators.maxLength(15)),
      daEmisionCo2: new FormControl(""), //number
      daEmisionesExtraurb: new FormControl(""), //number
      daEmisionesUrbanas: new FormControl(""), //number
      daEmplazAsientos: new FormControl("", Validators.maxLength(50)),
      daEscapeEnsayo1Co: new FormControl(""), //number
      daEscapeEnsayo1Hc: new FormControl(""), //number
      daEscapeEnsayo1Hcnox: new FormControl(""), //number
      daEscapeEnsayo1Humo: new FormControl(""), //number
      daEscapeEnsayo1Nox: new FormControl(""), //number
      daEscapeEnsayo1Partic: new FormControl(""), //number
      daEscapeEnsayo2Co: new FormControl(""), //number
      daEscapeEnsayo2Hc: new FormControl(""), //number
      daEscapeEnsayo2Hcnox: new FormControl(""), //number
      daEscapeEnsayo2Humo: new FormControl(""), //number
      daEscapeEnsayo2Nox: new FormControl(""), //number
      daEscapeEnsayo2Partic: new FormControl(""), //number
      daExtension: new FormControl("", Validators.maxLength(2)),
      daFabMarcaMotor: new FormControl("", Validators.maxLength(25)),
      daFechaHomologacion: new FormControl(""), //date
      daHumos: new FormControl(""), //number
      daId: new FormControl(""), //number
      daIndEcoinnovacion: new FormControl("", Validators.maxLength(1)),
      daInyeccDirecta: new FormControl("", Validators.maxLength(3)),
      daLlantasAnterior: new FormControl("", Validators.maxLength(250)),
      daLlantasPosterior: new FormControl("", Validators.maxLength(250)),
      daLongitudMax: new FormControl(""), //number
      daLongitudMaximaAdmMax: new FormControl(""), //number
      daLongitudMaximaAdmMin: new FormControl(""), //number
      daLongitudMin: new FormControl(""), //number
      daMarca: new FormControl("", Validators.maxLength(25)),
      daMarcaHomolCeDispEng: new FormControl("", Validators.maxLength(50)),
      daMarcaHomolDispEng: new FormControl("", Validators.maxLength(50)),
      daMasaMinimaAdmisibleMax: new FormControl(""), //number
      daMasaMinimaAdmisibleMin: new FormControl(""), //number
      daMma1Max: new FormControl(""), //number
      daMma1Min: new FormControl(""), //number
      daMma2Max: new FormControl(""), //number
      daMma2Min: new FormControl(""), //number
      daMmaMax: new FormControl(""), //number
      daMmaMin: new FormControl(""), //number
      daMmacMax: new FormControl(""), //number
      daMmacMin: new FormControl(""), //number
      daMmrBarraTraccion: new FormControl(""), //number
      daMmrConFrenos: new FormControl(""), //number
      daMmrSemiremolque: new FormControl(""), //number
      daMmrSinFrenos: new FormControl(""), //number
      daMmta1Max: new FormControl(""), //number
      daMmta1Min: new FormControl(""), //number
      daMmta2Max: new FormControl(""), //number
      daMmta2Min: new FormControl(""), //number
      daMmtaConjunto: new FormControl("", Validators.maxLength(11)),
      daMmtaMax: new FormControl(""), //number
      daMmtaMin: new FormControl(""), //number
      daMmtcMax: new FormControl(""), //number
      daMmtcMin: new FormControl(""), //number
      daMomMax: new FormControl(""), //number
      daMomMin: new FormControl(""), //number
      daNeumaticosAnterior: new FormControl("", Validators.maxLength(250)),
      daNeumaticosPosterior: new FormControl("", Validators.maxLength(250)),
      daNivelEmisiones: new FormControl("", Validators.maxLength(10)),
      daNivelRuidoParadoU1: new FormControl(""), //number
      daNivelRuidoParadoU2: new FormControl(""), //number
      daNomFabBase: new FormControl("", Validators.maxLength(50)),
      daNomFabUlt: new FormControl("", Validators.maxLength(50)),
      daNumAsientosSinConduc: new FormControl(""), //number
      daNumDepositos: new FormControl(""), //number
      daNumPuertas: new FormControl(""), //number
      daNumeroCilindros: new FormControl(""), //number
      daNumeroPlazasAsiento: new FormControl(""), //number
      daObsCoc: new FormControl("", Validators.maxLength(250)),
      daObsFamilia: new FormControl("", Validators.maxLength(250)),
      daObsOpcHomol: new FormControl("", Validators.maxLength(250)),
      daParteFijaVin: new FormControl("", Validators.maxLength(17)),
      daPotNominalKw: new FormControl("", Validators.maxLength(4)),
      daPotencia: new FormControl(""), //number
      daPotenciaNominal: new FormControl("", Validators.maxLength(7)),
      daPrincipioMotor: new FormControl("", Validators.maxLength(50)),
      daProcedencia: new FormControl("", Validators.maxLength(5)),
      daRegimenGiroPotMax: new FormControl(""), //number
      daRpmCorte: new FormControl("", Validators.maxLength(40)),
      daRuedas: new FormControl(""), //number
      daRuedasGemelas: new FormControl("", Validators.maxLength(50)),
      daTcambio: new FormControl("", Validators.maxLength(3)),
      daTcarroceria: new FormControl("", Validators.maxLength(2)),
      daTcarroceriaDesc: new FormControl("", Validators.maxLength(25)),
      daTextoEcoinn: new FormControl("", Validators.maxLength(4)),
      daTipo: new FormControl("", Validators.maxLength(10)),
      daAutoridadGnc: new FormControl("", Validators.maxLength(3)),
      daTipoCaja: new FormControl("", Validators.maxLength(50)),
      daTipoEmbrague: new FormControl("", Validators.maxLength(50)),
      daTipoVehiElec: new FormControl("", Validators.maxLength(4)),
      daTmotor: new FormControl("", Validators.maxLength(4)),
      daTraccion: new FormControl("", Validators.maxLength(10)),
      daVariante: new FormControl("", Validators.maxLength(25)),
      daVelocidadMaxima: new FormControl(""), //number
      daVersion: new FormControl("", Validators.maxLength(35)),
      daViaEjeAnteriorMax: new FormControl(""), //number
      daViaEjeAnteriorMin: new FormControl(""), //number
      daViaEjePosteriorMax: new FormControl(""), //number
      daViaEjePosteriorMin: new FormControl(""), //number
      daVoladMaxPostCarr: new FormControl("", Validators.maxLength(11)),
      daVoladizoTraseroMax: new FormControl(""), //number
      daVoladizoTraseroMin: new FormControl(""), //number
      daVolumenBodega: new FormControl("", Validators.maxLength(20)),
    });
  }
}
